import NUIAlert from '@/components/Alert/Alert'
import { IConfigSeller } from '@/models/configSeller'
import { IAppStore } from '@/models/store.model'
import { webApiService } from '@/services'
import { blobToBase64 } from '@/utils/blobToBase64.util'
import { currencyFormat } from '@/utils/currencyFormat'
import { cn, Switch } from '@nextui-org/react'
import { fromImage } from 'imtool'
import { enqueueSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import { MdLocalOffer } from 'react-icons/md'
// import { Accept, useDropzone } from 'react-dropzone'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Button, useButtonClasses } from '@/components/ui/button'
import StepCard from './StepCard'
import { useStepFooterAction } from '../context/StepFooterActionContext'
import { useTradeinContext } from '../hooks/useTradeinContext'
import { getGradle } from '@/utils/getGradle'

const Discounts = () => {
  const { ctx, saveCtx } = useTradeinContext()
  const buttonClasses = useButtonClasses()
  const userState = useSelector((store: IAppStore) => store.user)
  const [discounts, setDiscounts] = useState<{ haveCharger: boolean, isBatteryHealthy: boolean }>({ haveCharger: true, isBatteryHealthy: true })
  const [data, setData] = useState<{ loading: boolean, imagen: string }>({ loading: false, imagen: '' })
  const [gradles, setGradles] = useState<any>()
  const { slug, id: idParam } = useParams()
  // Fuera de la ruta del detalle (modal del listado) el id no viene en la url, se toma del contexto.
  const id = idParam ?? String(ctx.tradein.id)
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isSamsungPeru = configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe'
  const isMacstoreMexico = configSeller.config.s3.FOLDER_APP === 'ti_macstore'
  const isOppoMexico = configSeller.config.s3.FOLDER_APP === 'ti_oppo'
  const isElektraMexico = configSeller.config.s3.FOLDER_APP === 'ti_elektra_mx'
  const isXiaomiMexico = configSeller.config.s3.FOLDER_APP === 'ti_xiaomi'
  const isCoppelMexico = configSeller.config.s3.FOLDER_APP === 'ti_coppel'
  // const isSamsungMexico = configSeller.config.s3.FOLDER_APP === 'ti_samsung_mx'
  const isSamsungRom = configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe_rom'
  const isMercadoLibreChile = configSeller.config.s3.FOLDER_APP === 'ti_mercado_libre_cl'
  const isTelcelCorpMexico = configSeller.config.s3.FOLDER_APP === 'ti_telcel_corp_mx'
  const isTelcelMexico = configSeller.config.s3.FOLDER_APP === 'ti_telcel_mx'
  // Telcel (retail y corporativo) no pide la foto de evidencia de la capacidad de carga: el
  // operador solo marca el switch y guarda con "Actualizar estado de bateria".
  const enableBatteryImageUpload = (isTelcelCorpMexico || isTelcelMexico) ? 0 : configSeller.config.permisos.ENABLE_BATTERY_IMAGE_UPLOAD
  // En Telcel (retail y corporativo) la batería siempre se evalúa acá, sin depender de
  // ENABLE_CHECK_BATTERY del seller: sin esto el switch queda deshabilitado y el paso no se puede cerrar.
  const enableCheckBattery = (isTelcelCorpMexico || isTelcelMexico) ? 1 : configSeller.config.permisos.ENABLE_CHECK_BATTERY
  /* Sellers donde la bateria bajo 80% no descuenta un monto fijo sino que baja el grado del
     equipo y el precio lo recalcula el backend por grado: por eso "Monto a descontar" queda
     en 0 y el monto del tradein no se toca al guardar. */
  const useGradeBatteryDiscount = isMacstoreMexico || isOppoMexico || isElektraMexico || isXiaomiMexico || isMercadoLibreChile || isCoppelMexico || isTelcelMexico
  /* Grado al que baja el equipo cuando la bateria no supera el 80%. Telcel no maneja grado C,
     asi que ahi el tope es B (A → B, y un B se queda en B). */
  const gradeAfterUnhealthyBattery = isTelcelMexico ? 'B' : 'C'

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file) return
    const imageCompression = (await import('browser-image-compression')).default
    const compressed: any = await imageCompression(file, {
      maxSizeMB: 0.8,
      maxWidthOrHeight: 800,
      useWebWorker: true
    })

    compressed.path = compressed.name

    saveCtx({
      ...ctx,
      files: [compressed]
    })
  }

  const removeFile = (file: File, event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    saveCtx({
      ...ctx,
      files: ctx.files.filter(f => f !== file)
    })
  }

  const uploadImage = async () => {
    for (const element of ctx.files) {
      if (element.nameFile === undefined) {
        console.log('entro', ctx)
        delete element.preview
        element.blob = await fromImage(element).then((tool: any) => tool.thumbnail(800, false).toBlob())
        element.base64 = await blobToBase64(element.blob)
        delete element.blob
      }
    }
    console.log('🚀 ~ forawait ~ ctx.files:', ctx.files)
    setData({ ...data, loading: true })

    let _discount = ctx.tradein.new_discount_amount !== null ? ctx.tradein.new_discount_amount : ctx.tradein.discount_amount
    console.log('🚀 ~ uploadImage ~ _discount:', _discount)
    if (!discounts.haveCharger) {
      _discount = _discount - Number(import.meta.env.VITE_CHARGER_DISCOUNT)
      _discount = _discount < 0 ? 0 : _discount
      console.log('🚀 ~ :', _discount, Number(import.meta.env.VITE_CHARGER_DISCOUNT))
    }
    if (!discounts.isBatteryHealthy) {
      _discount = _discount - Number(import.meta.env.VITE_BATTERY_DISCOUNT)
      _discount = _discount < 0 ? 0 : _discount
      console.log('🚀 ~ :', _discount, Number(import.meta.env.VITE_BATTERY_DISCOUNT))
    }

    /* logica para Samsung ROM en base a bateria no saludable */
    const currentGrade = getGradle(String(ctx.tradein.grade), String(ctx.tradein.grade_IA))
    let nextGrade = currentGrade

    if ((isSamsungRom) && !discounts.isBatteryHealthy) {
      _discount = ctx.tradein.new_discount_amount !== null ? ctx.tradein.new_discount_amount : ctx.tradein.discount_amount
      _discount = _discount - getMontoDiscount(0)
      if (currentGrade === 'A' || currentGrade === 'B') { nextGrade = 'C' } else if (currentGrade === 'C') { nextGrade = 'D' }
    }

    if (useGradeBatteryDiscount && !discounts.isBatteryHealthy) {
      _discount = ctx.tradein.new_discount_amount !== null ? ctx.tradein.new_discount_amount : ctx.tradein.discount_amount
      _discount = _discount - getMontoDiscount(0)
      nextGrade = gradeAfterUnhealthyBattery
    }

    webApiService.saveFiles({ id, store_user: String(userState.id), files: ctx.files, seller: slug, battery: true, isBatteryHealthy: Number(discounts.isBatteryHealthy), discount: _discount, haveCharger: discounts.haveCharger, nextGrade, batteryDiscount: getMontoDiscount(0) }).then(() => {
      enqueueSnackbar(ctx.files.length > 0 ? 'Imagen cargada con exito' : 'Información cargada con exito', { variant: 'success' })
      saveCtx({ ...ctx, files: [], reload: true })
      setData({ ...data, loading: false })
    }).catch((error) => {
      const msg = error.response?.data.message ?? error.message ?? 'No fue posible cargar la imagen.'
      saveCtx({ ...ctx, files: [], reload: true })
      enqueueSnackbar(msg, { variant: 'error' })
      console.log('error ==>', msg)
      setData({ ...data, loading: false })
    })
  }

  const updateBatteryStatus = async () => {
    setData({ ...data, loading: true })
    try {
      let _discount = ctx.tradein.new_discount_amount !== null ? ctx.tradein.new_discount_amount : ctx.tradein.discount_amount
      console.log('🚀 ~ uploadImage ~ _discount:', _discount)
      if (!discounts.haveCharger) {
        _discount = _discount - Number(import.meta.env.VITE_CHARGER_DISCOUNT)
        _discount = _discount < 0 ? 0 : _discount
        console.log('🚀 ~ :', _discount, Number(import.meta.env.VITE_CHARGER_DISCOUNT))
      }
      if (!discounts.isBatteryHealthy) {
        _discount = _discount - Number(import.meta.env.VITE_BATTERY_DISCOUNT)
        _discount = _discount < 0 ? 0 : _discount
        console.log('🚀 ~ :', _discount, Number(import.meta.env.VITE_BATTERY_DISCOUNT))
      }

      /* logica para Samsung ROM en base a bateria no saludable */
      const currentGrade = getGradle(String(ctx.tradein.grade), String(ctx.tradein.grade_IA))
      let nextGrade = currentGrade

      if ((isSamsungRom) && !discounts.isBatteryHealthy) {
        _discount = ctx.tradein.new_discount_amount !== null ? ctx.tradein.new_discount_amount : ctx.tradein.discount_amount
        console.warn(_discount)
        _discount = _discount - getMontoDiscount(0)
        if (currentGrade === 'A' || currentGrade === 'B') { nextGrade = 'C' } else if (currentGrade === 'C') { nextGrade = 'D' }
      }

      if (useGradeBatteryDiscount && !discounts.isBatteryHealthy) {
        _discount = ctx.tradein.new_discount_amount !== null ? ctx.tradein.new_discount_amount : ctx.tradein.discount_amount
        _discount = _discount - getMontoDiscount(0)
        nextGrade = gradeAfterUnhealthyBattery
      }
      const updateBattery = await webApiService.updateBatteryStatus({ id: Number(id), isBatteryHealthy: discounts.isBatteryHealthy ? 1 : 0, seller: slug, nextGrade, batteryDiscount: getMontoDiscount(0), store_user: String(userState.id), discount: _discount })
      if (updateBattery) {
        enqueueSnackbar('Estado de batería actualizado con éxito', { variant: 'success' })
        saveCtx({ ...ctx, reload: true })
        setData({ ...data, loading: false })
      }
    } catch (error) {
      console.log('error ==>', error)
      enqueueSnackbar('Error al actualizar el estado de la batería', { variant: 'error' })
    }
  }

  const loadData = () => {
    // if (ctx.tradein.brand === 'Apple' && ctx.tradein.sbu === 'Smartphone' && ctx.tradein.isBatteryHealthy === 1) return
    setData({ ...data, loading: true })
    webApiService.getFiles(String(id)).then((res: any) => {
      setData({ loading: false, imagen: res.data.find((item: any) => item.name.includes('batteryHealth'))?.name ?? null })
    }).catch((error) => {
      enqueueSnackbar(error.message, { variant: 'error' })
      console.log('error ==>', error)
      setData({ ...data, loading: false })
    })
  }

  useEffect(() => {
    if (!isSamsungRom && !useGradeBatteryDiscount) return
    webApiService.getAllCapacityByModel({ idSbu: String(ctx.tradein.id_sbu), idBrand: String(ctx.tradein.brand), idModel: String(ctx.tradein.model), seller: String(slug) }).then((res) => {
      console.warn('RES DATA', res.data)
      setGradles(res.data)
    }).catch((error) => {
      /* Sin catalogo no hay con que calcular por grado, pero tampoco corresponde caer al monto
         fijo de bateria: se deja la lista vacia para que el monto quede en 0. */
      console.log('Error cargando capacidades por modelo:', error)
      setGradles([])
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx.tradein.id_sbu, ctx.tradein.brand, ctx.tradein.model, slug])

  const getMontoDiscount : (monto: number) => number = (monto) => {
    let _discount = monto
    console.log('monto', monto)
    console.log('isSamsungRom:', isSamsungRom, 'gradles:', gradles)
    console.log('isXiaomiMexico:', isXiaomiMexico, 'isOppoMexico:', isOppoMexico, 'gradles:', gradles)
    if ((isSamsungRom) && gradles) {
      console.error('gradles~~~~~~~~~~1', gradles)
      if (ctx.tradein.batteryDiscount) _discount = ctx.tradein.batteryDiscount
      console.log('ctx.tradein.batteryDiscount:', ctx.tradein.batteryDiscount)
      const filterByRam = gradles.filter((item: any) => item.capacity === ctx.tradein.capacity)
      console.log('filterByRam:', filterByRam)
      console.log('discounts.isBatteryHealthy ', discounts.isBatteryHealthy, 'ctx.tradein.batteryDiscount ', ctx.tradein.batteryDiscount)
      if (!discounts.isBatteryHealthy && !ctx.tradein.batteryDiscount) {
        const currentGrade = getGradle(String(ctx.tradein.grade), String(ctx.tradein.grade_IA))
        console.log('currentGrade:', currentGrade)
        let nextGrade = currentGrade
        console.log('nextGrade before:', nextGrade)
        if (currentGrade === 'A' || currentGrade === 'B') { nextGrade = 'C' } else if (currentGrade === 'C') { nextGrade = 'D' }
        const grade = filterByRam.find((item: any) => item.grade === nextGrade)
        console.log('grade:', grade)
        _discount = grade ? ctx.tradein.new_discount_amount ? ctx.tradein.new_discount_amount - grade.amount : ctx.tradein.discount_amount - grade.amount : 0
      }
    } else if (useGradeBatteryDiscount && gradles) {
      console.log('gradles~~~~~~~~~~2', gradles)
      if (ctx.tradein.batteryDiscount) _discount = ctx.tradein.batteryDiscount
      const filterByRam = gradles.filter((item: any) => item.capacity === ctx.tradein.capacity)
      console.log('discounts.isBatteryHealthy ', discounts.isBatteryHealthy, 'ctx.tradein.batteryDiscount ', ctx.tradein.batteryDiscount)
      if (!discounts.isBatteryHealthy && !ctx.tradein.batteryDiscount) {
        // const currentGrade = getGradle(String(ctx.tradein.grade), String(ctx.tradein.grade_IA))
        // let nextGrade = currentGrade
        const nextGrade = gradeAfterUnhealthyBattery
        const grade = filterByRam.find((item: any) => item.grade === nextGrade)
        console.log('🚀 ~ Discounts ~ grade:', grade)
        console.log('🚀 ~ Discounts ~ ctx.tradein.new_discount_amount:', ctx.tradein.new_discount_amount, grade?.amount, ctx.tradein.discount_amount)
        _discount = 0 // grade ? ctx.tradein.new_discount_amount ? ctx.tradein.new_discount_amount - grade.amount : ctx.tradein.discount_amount - grade.amount : 0
      }
    } else {
      console.log('gradles~~~~~~~~~~3', gradles)
      if (!discounts.haveCharger || ctx.tradein.haveCharger === 0) {
        _discount = _discount + Number(import.meta.env.VITE_CHARGER_DISCOUNT)
      }
      if (!discounts.isBatteryHealthy || ctx.tradein.isBatteryHealthy === 0) {
        _discount = _discount + Number(import.meta.env.VITE_BATTERY_DISCOUNT)
      }
    // if (ctx.tradein.brand === 'Apple' && ctx.tradein.sbu === 'Smartphone' && (ctx.tradein.batteryHealthPercentage !== '' || ctx.tradein.batteryHealthPercentage != null)) {
    //   const batteryHealthPercentage = Number(ctx.tradein.batteryHealthPercentage?.split(' ')[0])
    //   _discount = batteryHealthPercentage >= 80 ? 0 : _discount + Number(import.meta.env.VITE_BATTERY_DISCOUNT)
    // }
    }
    return _discount
  }

  useEffect(() => {
    if (ctx.tradein.isBatteryHealthy !== null && ctx.tradein.sbu !== 'Smartwatch') loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx.tradein.isBatteryHealthy])

  const showAlertOnly = ctx.tradein.id_status === 1 || (isSamsungPeru && ctx.formAnswers.length === 0) || (ctx.tradein.recalculate === '1' && ctx.tradein.wasRecalculated === null)

  const uploadImageButton = (
    <Button disabled={data.loading || (ctx.files.length === 0 && ctx.tradein.sbu !== 'Smartwatch')} onClick={uploadImage}>
      {data.loading ? 'Cargando...' : ctx.tradein.sbu === 'Smartwatch' ? 'Enviar' : 'Cargar imagen'}
    </Button>
  )

  const updateBatteryStatusButton = (
    <Button disabled={data.loading || ctx.tradein.isBatteryHealthy !== null} onClick={updateBatteryStatus}>
      {data.loading ? 'Actualizando...' : 'Actualizar estado de batería'}
    </Button>
  )

  const inlineAction = useStepFooterAction(
    showAlertOnly
      ? null
      : ctx.tradein.haveCharger === null && enableBatteryImageUpload === 1 && !isMacstoreMexico
        ? uploadImageButton
        : ctx.tradein.isBatteryHealthy === null && enableBatteryImageUpload === 0
          ? (ctx.tradein.sbu === 'Smartwatch' || ctx.tradein.sbu === 'Notebook' ? uploadImageButton : updateBatteryStatusButton)
          : null,
    [data.loading, ctx.files.length, ctx.tradein.sbu, ctx.tradein.haveCharger, ctx.tradein.isBatteryHealthy, enableBatteryImageUpload, showAlertOnly, isMacstoreMexico]
  )

  return (
    <StepCard
      icon={<MdLocalOffer />}
      title='Descuentos'
      className='h-full'
      right={!showAlertOnly && (
        <div className='text-end font-black text-lg whitespace-nowrap'>Monto {ctx.tradein.haveCharger === null ? 'a descontar' : 'descontado'}: <span className='text-primary'>{currencyFormat(getMontoDiscount(0), import.meta.env.VITE_COUNTRY)}</span></div>
      )}
    >
      {/* {JSON.stringify(discounts)} */}
      {
      ctx.tradein.id_status === 1 || (isSamsungPeru && ctx.formAnswers.length === 0)
        ? (
          <NUIAlert type='info'>Se requiere el resultado de la evaluación técnica.</NUIAlert>
          )
        : ctx.tradein.recalculate === '1' && ctx.tradein.wasRecalculated === null
          ? (
            <NUIAlert type='info'>Se requiere recalcular el dispositivo.</NUIAlert>
            )
          : (
            <div>
              {
        ctx.tradein.haveCharger === null && (ctx.tradein.sbu === 'Notebook' || ctx.tradein.sbu === 'Smartwatch')
          ? (
            <Switch
              isSelected={!discounts.haveCharger} onValueChange={(value) => setDiscounts({ ...discounts, haveCharger: !value })}
              classNames={{
                base: cn(
                  'inline-flex flex-row-reverse w-full max-w-full bg-content1 hover:bg-content2 items-center',
                  'justify-between cursor-pointer rounded-lg gap-2 p-4 border-2 border-transparent',
                  'data-[selected=true]:border-primary'
                ),
                wrapper: 'p-0 h-4 overflow-visible',
                thumb: cn('w-6 h-6 border-2 shadow-lg',
                  'group-data-[hover=true]:border-primary',
                  // selected
                  'group-data-[selected=true]:ml-6',
                  // pressed
                  'group-data-[pressed=true]:w-7',
                  'group-data-[selected]:group-data-[pressed]:ml-4'
                )
              }}
            >
              <div className='flex flex-col gap-1'>
                <p className='text-medium'>¿Se entrega dispositivo sin cargador?</p>
              </div>
            </Switch>
            )
          : null
      }
              <span />
              {
        (ctx.tradein.isBatteryHealthy === null && ctx.tradein.sbu !== 'Smartwatch' && ctx.tradein.sbu !== 'Notebook') || (enableBatteryImageUpload === 0 && ctx.tradein.isBatteryHealthy !== null && ctx.tradein.sbu !== 'Notebook' && ctx.tradein.sbu !== 'Smartwatch')
          ? (
            <div className='py-2'>
              <Switch
                isDisabled={(enableCheckBattery === 0) || (enableBatteryImageUpload === 0 && ctx.tradein.isBatteryHealthy !== null)}
                isSelected={ctx.tradein.isBatteryHealthy !== null ? Boolean(!ctx.tradein.isBatteryHealthy) : !discounts.isBatteryHealthy} onValueChange={(value) => setDiscounts({ ...discounts, isBatteryHealthy: !value })}
                classNames={{
                  base: cn(
                    'inline-flex flex-row-reverse w-full max-w-full bg-content1 hover:bg-content2 items-center',
                    'justify-between cursor-pointer rounded-lg gap-2 p-4 border-2 border-transparent',
                    'data-[selected=true]:border-primary'
                  ),
                  wrapper: 'p-0 h-4 overflow-visible',
                  thumb: cn('w-6 h-6 border-2 shadow-lg',
                    'group-data-[hover=true]:border-primary',
                    // selected
                    'group-data-[selected=true]:ml-6',
                    // pressed
                    'group-data-[pressed=true]:w-7',
                    'group-data-[selected]:group-data-[pressed]:ml-4'
                  )
                }}
              >
                <div className='flex flex-col gap-1'>
                  <p className='text-medium'>¿La capacidad de carga del dispositivo es menor al 80%?</p>
                </div>
              </Switch>
              <div className='pt-2' hidden={enableBatteryImageUpload === 0}>
                <NUIAlert type='info'>Para avanzar debe subir foto de la evidencia del estado de capacidad máxima de carga de la batería</NUIAlert>
                <div
                  style={{
                    border: ctx.files.length > 0 ? '1px solid #ccc' : '1px dashed #ff8181',
                    borderRadius: '5px',
                    padding: '20px',
                    textAlign: 'center',
                    marginTop: '6px',
                    backgroundColor: ctx.files.length > 0 ? '#fff' : '#ffefef',
                    color: '#000000'
                  }}
                >
                  <input
                    type='file'
                    accept='image/png, image/jpg, image/jpeg'
                    id='file-input-battery'
                    className='hidden'
                    onChange={handleFileChange}
                  />
                  <label htmlFor='file-input-battery' hidden={ctx.files.length > 0}>
                    <span className={cn(buttonClasses({ size: 'sm', legacyColor: 'warning' }), 'bg-amber-500 text-white hover:bg-amber-600 cursor-pointer')}>Adjuntar imagen capacidad de carga del dispositivo (Requerido)</span>
                  </label>
                  <p color='textSecondary' hidden={ctx.files.length > 0}>
                    (Solo se permiten archivos .png, .jpg y .jpeg)
                  </p>
                  <div className='grid grid-cols-1'>
                    {ctx.files.map((file, index) => (
                      <div key={index} className='max-w-44'>
                        <img src={URL.createObjectURL(file)} alt={`preview ${index}`} />
                        <p>{file.name}</p>
                        <Button variant='destructive' size='sm' onClick={(event: any) => removeFile(file, event)}>
                          Eliminar
                        </Button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            )
          : null
      }

              {
        ctx.tradein.haveCharger !== null && ctx.tradein.sbu !== 'Smartphone'
          ? (
            <div className='p-4 bg-slate-100 border-1 border-slate-500 rounded-lg mb-2'>
              <p className='text-large font-bold'> {ctx.tradein.haveCharger === 1 ? 'Dispositivo se entrega con cargador' : 'Dispositivo se entrega sin cargador'} </p>
            </div>
            )
          : null
      }
              {
        ctx.tradein.isBatteryHealthy !== null && data.imagen !== null && ctx.tradein.sbu !== 'Smartwatch'
          ? (
        // ctx.tradein.isBatteryHealthy === 1 && ctx.tradein.batteryHealthPercentage !== '' && ctx.tradein.batteryHealthPercentage != null)
        // ? (
        //   <div className='flex justify-center items-center h-3/4'>
        //     <div className='flex gap-2'>
        //       <h6 className='font-medium text-xl pb-2'>Porcentaje de Bateria</h6>
        //       <p className='text-end font-black text-lg text-primary'>{ctx.tradein.batteryHealthPercentage}</p>
        //     </div>
        //   </div>
        //   )
        // : (
            <div className='p-4 bg-slate-100 border-1 border-slate-500 rounded-lg'>
              <p className='text-large pb-4 font-bold'> {ctx.tradein.isBatteryHealthy === 1 ? 'Mayor ó igual al 80%' : 'No supera el 80%'} </p>
              <img
                className={isSamsungPeru ? 'h-[400px]' : 'w-full'}
                src={`https://${import.meta.env.VITE_BUCKET}.s3.us-west-2.amazonaws.com/${configSeller.config.s3.FOLDER_APP}/imagenes/${id}/${data.imagen}`} alt={ctx.tradein.isBatteryHealthy === 1 ? 'Mayor ó igual al 80%' : 'No supera el 80%'}
              />
            </div>
            )
          : ctx.tradein.isBatteryHealthy === 1 && data.imagen === null && (enableBatteryImageUpload === 1)
            ? (
              <div className='d-flex justify-content-center align-items-center h-100'>
                <div className='d-flex gap-2 align-items-center'>
                  <h6 className='m-0'>Porcentaje de Bateria</h6>
                  <p className='text-primary fw-bold m-0'>{ctx.tradein.batteryHealthPercentage}</p>
                </div>
              </div>
              )
            : null
      }

            </div>)
      }

      {/* Sin footer compartido (página de detalle clásica) el botón del paso se dibuja acá. */}
      {inlineAction && <div className='flex justify-end pt-4'>{inlineAction}</div>}
    </StepCard>
  )
}

export default Discounts
